if (!window.collectionSubcategoryTabsInitialized) {
  window.collectionSubcategoryTabsInitialized = true;

  const desktopMedia = window.matchMedia('(min-width: 66.001em)');

  const initCollectionSubcategoryTabs = (root = document) => {
    root.querySelectorAll('.subcategory-tabs-overflow').forEach((tabs) => {
      if (tabs.dataset.horizontalWheelInitialized == 'true') return;

      tabs.dataset.horizontalWheelInitialized = 'true';
      tabs.addEventListener('wheel', (event) => {
        if (!desktopMedia.matches || Math.abs(event.deltaX) >= Math.abs(event.deltaY)) return;

        const maxScrollLeft = tabs.scrollWidth - tabs.clientWidth;
        if (maxScrollLeft <= 0) return;

        const atStart = tabs.scrollLeft <= 0;
        const atEnd = tabs.scrollLeft >= maxScrollLeft - 1;
        if ((event.deltaY < 0 && atStart) || (event.deltaY > 0 && atEnd)) return;

        event.preventDefault();
        tabs.scrollLeft += event.deltaY;
      }, { passive: false });
    });
  };

  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectionSubcategoryTabs());
  } else {
    initCollectionSubcategoryTabs();
  }

  document.addEventListener('shopify:section:load', (event) => initCollectionSubcategoryTabs(event.target));
}
